import React from 'react';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import { AUTH_POST_PASSWORD_RESET_LINK } from '../../../config/api';
import http from '../../../config/http';
import { _route } from '../../../utils';

const useStyles = makeStyles(() => ({
  textField: {
    padding: '0px!important',
    fontSize: '16px!important',
    fontFamily: 'Inter !important',
    fontWeight: '400',
    marginTop: '8px!important',
    transition: '.3s',
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
      lineHeight: '1em',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      // border: '1px solid #5433FF',
    },
    '& .MuiFormHelperText-root': {
      letterSpacing: '0 !important',
      fontFamily: 'Inter',
      margin: '6px 0 0 0 !important',
      fontWeight: '500',
    },
    '& .MuiOutlinedInput-root .MuiInputBase-input': {
      borderRadius: '8px',
      background: '#fff',
      fontSize: '14px !important',
      // border: '1px solid #D0D5DD',
      boxShadow: ' 0px 1px 2px rgb(16 24 40 / 5%)',
      padding: '13.5px 14px',
      transition: '.3s',
      '&:focus': {
        transition: '.3s',
        outline: '0',
        boxShadow: 'inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%)',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px !important',
    },
  },
}));

const buttonStyles = {
  borderRadius: '10px',
  boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  width: '100%',
  padding: '10px 14px',
  color: '#fff',
  transition: '0.2s',
  marginTop: '5px',
  fontWeight: '500',
  backgroundColor: '#5433ff',
  borderColor: '#5433ff',
  border: '1px solid #5433ff',
  fontFamily: 'Inter',
  letterSpacing: '0',
  textTransform: 'inherit',
  '&:hover': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:focus': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
  '&:visited': {
    backgroundColor: '#5433FF',
    borderColor: '#5433FF',
    opacity: '0.9',
    boxShadow: '0 4px 11px rgb(0 0 0 / 11%)',
  },
};

export default function ForgotPass() {
  const classes = useStyles();
  const RegisterSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: RegisterSchema,
    onSubmit: async () => {
      try {
        await http.post(AUTH_POST_PASSWORD_RESET_LINK, { email: values.email });
        resetForm();
        toast.success('Email sent successfully');
      } catch (err) {
        toast.error(err.response.data.message);
      }
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, values, getFieldProps, resetForm } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <div className="customLabel">Email*</div>
          <TextField
            fullWidth
            type="email"
            placeholder="Email your email"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
            InputLabelProps={{ shrink: false }}
            className={classes.textField}
          />
          <LoadingButton sx={buttonStyles} fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
            Send me Reset Link
          </LoadingButton>
          <Button
            component={Link}
            to={_route('login')}
            fullWidth
            size="large"
            className="aisleLinkButton"
            style={{ textTransform: 'inherit', letterSpacing: '0', marginTop: '10px' }}
          >
            Return to sign in
          </Button>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
